import { Tab } from './ScrollableTabsTypes'

export const findTabIndex = (tabName: string, tabs: Tab[]) => {
  return tabs.findIndex(tab => tab.id === tabName)
}
